import { render, staticRenderFns } from "./RatingScaleSettings.vue?vue&type=template&id=1660dd0e&scoped=true"
import script from "./RatingScaleSettings.vue?vue&type=script&lang=js"
export * from "./RatingScaleSettings.vue?vue&type=script&lang=js"
import style0 from "./RatingScaleSettings.vue?vue&type=style&index=0&id=1660dd0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660dd0e",
  null
  
)

export default component.exports